import { iconFactory } from './icon.factory.ts'

export default iconFactory(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" transform="translate(-75, -101)">
	<path fill="#e44d26" d="M107.6 471l-33-370.4h362.8l-33 370.2L255.7 512"/>
	<path fill="#f16529" d="M256 480.5V131H404.3L376 447"/>
	<path fill="#ebebeb" d="M142 176.3h114v45.4h-64.2l4.2 46.5h60v45.3H154.4M156.4 336.3H202l3.2 36.3 50.8 13.6v47.4l-93.2-26"/>
	<path fill="#fff" d="M369.6 176.3H255.8v45.4h109.6M361.3 268.2H255.8v45.4h56l-5.3 59-50.7 13.6v47.2l93-25.8"/>
</svg>`,
    (mesh, position) => {
        if (position <= 1) {
            mesh.position.set(0, 0, 10)
        }
    },
)
